import { connect } from 'react-redux';
import MessagesListComponent from '../components/MessagesList';
import { messageWillbeReceived, 
  addMessage,
  clickedMessage,
  disableUserInput,
  // enableInput, // Commented out - not currently used
  enableCal,
  disableCal,
  addSelectList,
  clearSelectList,
  showSearchWebsiteMessage,
} from '../actions/index';

const mapDispatchToProps = dispatch => ({
  dispatch: () => {
    dispatch(messageWillbeReceived());
  },
  dispatchAddSelList: (item) => {
    dispatch(addSelectList(item));
  },
  dispatchClickedMessage: () => {
    dispatch(clickedMessage());
  },
  dispatchAddMessage: (text, author) => {
    const session = localStorage.getItem('key');
    dispatch(addMessage(text, author, session, true));
    dispatch(messageWillbeReceived());
    if (author === 'Me') {
      let counter = 1;
      let myInterval = setInterval(function() {
        if (counter === 3) {
          dispatch (showSearchWebsiteMessage());
        } else if(counter > 5) {
          clearInterval(myInterval); 
        }
        counter++;
      }, 1000);
    }
    dispatch(clearSelectList());
  },
  dispatchDisableInput: () => {
    dispatch(disableUserInput()) ;
  },
  dispatchEnableCal: () => {
    dispatch(enableCal()) ;
  },
  dispatchDisableCal: () => {
    dispatch(disableCal()) ;
  },
});

const MessagesList = connect(state => ({
  message: state.message,
  bot: state.bot,
  operators: state.operators,
}), mapDispatchToProps)(MessagesListComponent);
export default MessagesList;
